import { safeboxClientNoToken, authClient, authClientRequiredToken, safeboxClient } from 'myNet'
import { isUS, isJP } from 'conf'

const ROUTE = '/v1/auth'
const ROUTE_LANDING = '/auth'
const ROUTE_SAML = '/saml'

const AuthService = {
  checkExists: async (email) => {
    const response = await safeboxClientNoToken.get(`${ROUTE}/check-exists`, { email })
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message)
      err.code = code
      throw err
    }
    return response.data
  },
  sendOTP: async (email) => {
    const response = await safeboxClientNoToken.post(`${ROUTE}/email-verifications`, { email })
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message)
      err.code = code
      throw err
    }
    return response.data
  },
  verifyOTP: async (email, otp) => {
    const response = await safeboxClientNoToken.post(`${ROUTE}/verify-otp/public`, {
      email,
      otp_code: otp,
    })
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message)
      err.code = code
      throw err
    }
    return response.data
  },

  register: async (request) => {
    const response = await safeboxClientNoToken.post(`${ROUTE}/register`, request)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message)
      err.code = code
      throw err
    }
    return response.data
  },
  checkExsitsBasicAuth: async ({ email }) => {
    // US(safepassword.io)는 JP common-auth를 공유 호출하므로, 발신 도메인·링크·언어를
    // 리전별로 선택하도록 요청에 리전 신호를 함께 보낸다 (common-auth password_reset_region_aware_mail)
    let serviceRegion = 'KR'
    if (isUS()) serviceRegion = 'US'
    else if (isJP()) serviceRegion = 'JP'
    const response = await authClient.post(`${ROUTE_LANDING}/password-reset/request`, {
      email,
      service_region: serviceRegion,
    })
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message)
      err.code = code
      throw err
    }
    return response.data
  },
  verifyOTPBasicAuth: async ({ email, otp }) => {
    const response = await authClient.post(`${ROUTE_LANDING}/password-reset/verify`, {
      email,
      verification_code: otp,
    })
    return response.data
  },

  changePasswordBasicAuth: async ({ email, password }) => {
    const response = await authClient.post(`${ROUTE_LANDING}/password-reset/set-password`, {
      email,
      new_password: password,
    })
    return response.data
  },

  changeTemporaryPassword: async ({ currentPassword, newPassword }) => {
    const response = await authClientRequiredToken.patch(`${ROUTE_LANDING}/password/change`, {
      current_password: currentPassword,
      new_password: newPassword,
    })
    return response.data
  },
  otpVerify: async (request) => {
    const response = await safeboxClient.post(`${ROUTE}/verify-otp`, request)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message)
      err.code = code
      throw err
    }
    return response.data
  },
  discoverSaml: async (email) => {
    const response = await authClient.get(`${ROUTE_SAML}/discover`, { email })
    return response.data
  },
  loginSaml: async (ssoLoginUrl) => {
    const url = ssoLoginUrl.replace('/api/v1/', '/')
    const response = await authClient.get(url)
    return response.data
  },
}

export default AuthService
